<template>
  <div :class="$style.feedback_form">
    <template v-if="state === 'form'">
      <div :class="$style.feedback_form__text">
        <div :class="$style.feedback_form__title">
          {{ config.title }}
        </div>
        <div :class="$style.feedback_form__subtitle">
          {{ config.subtitle }}
        </div>
      </div>

      <div :class="$style.feedback_form__form">
        <div :class="[$style.feedback_form__textarea_wrapper, showError ? $style.feedback_form__textarea_wrapper_error : '']">
          <textarea
            v-model="message"
            :class="$style.feedback_form__textarea"
            :placeholder="config.placeholder"
            @input="handleInput"
          />
        </div>

        <div :class="$style.feedback_form__actions">
          <button
            type="button"
            :class="$style.feedback_form__submit"
            :disabled="isSubmitting"
            @click="handleSubmit"
          >
            <span v-if="!isSubmitting">
              {{ config.submitButtonText }}
            </span>
            <ve-progress
              v-else
              v-bind="loaderConfig"
            />
          </button>
        </div>
      </div>
    </template>

    <div v-else :class="$style.feedback_form__success">
      <div :class="$style.feedback_form__text">
        <div :class="$style.feedback_form__title">
          {{ config.successTitle }}
        </div>
        <div :class="$style.feedback_form__subtitle">
          {{ config.successSubtitle }}
        </div>
      </div>

      <button
        type="button"
        :class="$style.feedback_form__leave_another"
        @click="handleLeaveAnother"
      >
        {{ config.leaveAnotherText }}
      </button>
    </div>
  </div>
</template>

<script>
import feedbackHelper from '$$helpers/feedback';
import { VeProgress } from 'vue-ellipse-progress';
import { BUTTON_TYPE_TO_LOADER_CONFIG_MAP } from '../../../../../common/VueComponents/globalButton/vgpButton.config';
import toast from '../../../../../common/VueComponents/toast';

const FEEDBACK_CONFIGS = {
  feedback: {
    type: 'learning_center_feedback',
    title: () => __('lc_feedback_title'),
    subtitle: () => __('lc_feedback_subtitle'),
    placeholder: () => __('lc_feedback_placeholder'),
    submitButtonText: () => __('lc_feedback_send'),
    successTitle: () => __('lc_feedback_success_title'),
    successSubtitle: () => __('lc_feedback_success_subtitle'),
    successText: () => __('lc_feedback_success_text'),
    errorText: () => __('lc_feedback_error'),
  },
  translation_error: {
    type: 'learning_center_translation_error',
    title: () => __('lc_translation_error_title'),
    subtitle: () => __('lc_translation_error_subtitle'),
    placeholder: () => __('lc_translation_error_placeholder'),
    submitButtonText: () => __('lc_translation_error_send'),
    successTitle: () => __('lc_translation_error_success_title'),
    successSubtitle: () => __('lc_translation_error_success_subtitle'),
    successText: () => __('lc_translation_error_success_text'),
    errorText: () => __('lc_translation_error_error'),
    leaveAnotherText: () => __('lc_translation_error_leave_another'),
  },
};

export default {
  name: 'LearningCenterFeedbackForm',
  components: {
    VeProgress,
  },
  props: {
    formType: {
      type: String,
      required: true,
      validator(value) {
        return ['feedback', 'translation_error'].includes(value);
      },
    },
  },
  data() {
    return {
      state: 'form', // 'form' | 'success'
      message: '',
      isSubmitting: false,
      showError: false,
    };
  },
  computed: {
    config() {
      const baseConfig = FEEDBACK_CONFIGS[this.formType];
      return {
        type: baseConfig.type,
        title: baseConfig.title(),
        subtitle: baseConfig.subtitle(),
        placeholder: baseConfig.placeholder(),
        submitButtonText: baseConfig.submitButtonText(),
        successTitle: baseConfig.successTitle(),
        successSubtitle: baseConfig.successSubtitle(),
        successText: baseConfig.successText(),
        errorText: baseConfig.errorText(),
        leaveAnotherText: baseConfig.leaveAnotherText ? baseConfig.leaveAnotherText() : __('lc_feedback_leave_another'),
      };
    },
    loaderConfig() {
      return BUTTON_TYPE_TO_LOADER_CONFIG_MAP.green || BUTTON_TYPE_TO_LOADER_CONFIG_MAP.primary;
    },
  },
  activated() {
    this.resetForm();
  },
  methods: {
    resetForm() {
      this.state = 'form';
      this.message = '';
      this.showError = false;
    },
    handleInput() {
      if (this.showError && this.message.trim().length > 0) {
        this.showError = false;
      }
    },
    async handleSubmit() {
      if (!this.message || !this.message.trim().length) {
        this.showError = true;
        return;
      }

      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;

      try {
        await feedbackHelper.send({
          type: this.config.type,
          message: this.message.trim(),
        });

        toast.success(this.config.successText, {
          timeout: 3000,
        });

        this.state = 'success';
        this.message = '';
        this.showError = false;
      } catch (e) {
        toast.error(this.config.errorText, {
          timeout: 5000,
        });
        throw e;
      } finally {
        this.isSubmitting = false;
      }
    },
    handleLeaveAnother() {
      this.resetForm();
    },
  },
};
</script>

<style module src="./learningCenterFeedbackForm.less" lang="less">
</style>

